import SVG from "./SVG";
import FilterColorful from "./Buttons/FilterColorful";
import CustomButton from "./Buttons/Custom";

export default function ContainerCustom({
  header = "",
  headSVG = "",
  headSVGClassName = "",
  search = true,
  searchValue,
  setSearchState = () => {
    return;
  },
  searchClick = () => {
    return;
  },
  filter = true,
  sort = true,
  colorfulFilter = true,
  colorfulFilterOptions = [],
  divider = true,
  children,
  activeFilter,
  setActiveFilter,
  className=""
}) {
  return (
    <div className={`w-full flex-1 overflow-auto p-5 rounded-2xl flex flex-col gap-5 bg-zi-bg2-light dark:bg-zi-bg2-dark ${className}`}>
      <div
        className={`w-full flex justify-between pb-2.5 ${
          divider &&
          "border-b border-zi-border-light/50 dark:border-zi-border-dark/50"
        }`}
      >
        <div className="w-full flex flex-col gap-5">
          <div className="w-full flex justify-between gap-5">
          <div className="flex gap-2.5 items-center">
            {headSVG && (
              <SVG
                name={headSVG}
                classname={`size-5 stroke-zi-border-dark dark:stroke-zi-border-light ${headSVGClassName}`}
              />
            )}
            {header && (
              <span className="text-lg font-medium whitespace-nowrap text-zi-text-light dark:text-zi-text-dark">
                {header}
              </span>
            )}
          </div>
          <div className="flex max-w-80">
          {search && (
            <div className="relative">
              <input
                value={searchValue}
                onChange={(e) => {
                  if (setSearchState !== null) {
                    setSearchState(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    searchClick();
                  }
                }}
                placeholder="جستجو"
                className="w-full !justify-start !rounded-lg !py-1.5 pr-2.5 pl-10 text-zi-text-light/50 dark:text-zi-text-dark/50 bg-zi-bg1-light dark:bg-zi-bg1-dark"
              />
              <button
                type="button"
                onClick={searchClick}
                className="absolute inset-y-0 left-0 flex items-center pl-2.5"
              >
                <SVG
                  name="search"
                  classname="size-5 stroke-zi-text-light/50 dark:stroke-zi-text-dark/50"
                />
              </button>
            </div>
          )}
          </div>
          </div>
          {colorfulFilter && colorfulFilterOptions.length > 0 && (
            <div className="flex gap-2.5">
              {colorfulFilterOptions.map((option, index) => (
                <FilterColorful
                  key={index}
                  SVGName={option.SVGName}
                  SVGClassName={option.SVGClassName}
                  text={option.text}
                  className={option.className}
                  color={activeFilter[index] ? option.color : "gray"}
                  activeFilter={activeFilter}
                  setActiveFilter={setActiveFilter}
                  filterIndex={index}
                />
              ))}
            </div>
          )}
        </div>

        {/* <div className="flex flex-col gap-5 w-80">
          {search && (
            <div className="relative">
              <input
                value={searchValue}
                onChange={(e) => {
                  if (setSearchState !== null) {
                    setSearchState(e.target.value);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    searchClick();
                  }
                }}
                placeholder="جستجو"
                className="w-full !justify-start !rounded-lg !py-1.5 pr-2.5 pl-10 text-zi-text-light/50 dark:text-zi-text-dark/50 bg-zi-bg1-light dark:bg-zi-bg1-dark"
              />
              <button
                type="button"
                onClick={searchClick}
                className="absolute inset-y-0 left-0 flex items-center pl-2.5"
              >
                <SVG
                  name="search"
                  classname="size-5 stroke-zi-text-light/50 dark:stroke-zi-text-dark/50"
                />
              </button>
            </div>
          )}
          <div className="flex gap-5">
            {filter && (
              <CustomButton
                text="فیلتر"
                className="w-full !justify-start !rounded-lg !py-1.5 pr-2.5 text-zi-text-light/50 dark:text-zi-text-dark/50 bg-zi-bg1-light dark:bg-zi-bg1-dark"
              />
            )}
            {sort && (
              <CustomButton
                text="مرتب‌سازی"
                className="w-full !justify-start !rounded-lg !py-1.5 pr-2.5 text-zi-text-light/50 dark:text-zi-text-dark/50 bg-zi-bg1-light dark:bg-zi-bg1-dark"
              />
            )}
          </div>
        </div> */}
      </div>
      {children}
    </div>
  );
}
